module.exports = __webpack_public_path__ + "static/media/image2.d53fe4a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/image2.png
// module id = 1256
// module chunks = 0